import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../services/analytics.service';
@Component({
  selector: 'app-help-support',
  standalone: true,
  imports: [CommonModule,RouterModule,],
  templateUrl: './help-support.component.html',
  styleUrl: './help-support.component.scss'
})
export class HelpSupportComponent {

  environment: any = environment;
customerCareInfo :any;
  constructor(public utils: UtilsService, public router: Router,public analyticsService:AnalyticsService) {

}
}
